{
  "name": "chemist2u-app-v2",
  "version": "3.9.72",
  "author": "Chemist2U Australia",
  "homepage": "https://www.chemist2u.com.au",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host=0.0.0.0 --port 4200",
    "start:staging": "npm run start -- --configuration staging",
    "build": "ng build && npm run sentry:sourcemaps",
    "build:staging": "ng build --configuration staging && npm run sentry:sourcemaps",
    "build:dev": "ng build --configuration development",
    "watch": "npm run build:dev -- --watch",
    "test": "ng test",
    "lint": "ng lint",
    "ios": "npx cap sync ios && npx cap run ios",
    "android": "npx cap sync android && npx cap open android",
    "get-version-info": "node get-version-info.js",
    "resources:android": "npx cordova-res android --skip-config --copy",
    "resources:ios": "npx cordova-res ios --skip-config --copy",
    "resources": "npm run resources:android && npm run resources:ios",
    "increment:patch:ios": "node increment-ios-versions.js patch",
    "increment:minor:ios": "node increment-ios-versions.js minor",
    "increment:major:ios": "node increment-ios-versions.js major",
    "increment:patch:android": "node increment-android-versions.js patch",
    "increment:minor:android": "node increment-android-versions.js minor",
    "increment:major:android": "node increment-android-versions.js major",
    "increment:patch": "npm run increment:patch:ios && npm run increment:patch:android",
    "increment:minor": "npm run increment:minor:ios && npm run increment:minor:android",
    "increment:major": "npm run increment:major:ios && npm run increment:major:android",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org chemist2u-australia --project chemist2u-app-v2-lw ./www && sentry-cli --url https://sentry.io/ sourcemaps upload --org chemist2u-australia --project chemist2u-app-v2-lw ./www",
    "e2e": "ng e2e",
    "cy:open": "cypress open",
    "cy:run": "cypress run",
    "cy:run:staging": "npm run cy:run -- --env NODE_ENV=staging",
    "precy:run": "npm run cy:del-report",
    "cy:clean-report": "npm run cy:merge-report && npm run cy:gen-report",
    "cy:merge-report": "mochawesome-merge cypress/reports/*.json > cypress/reports/index.json",
    "cy:gen-report": "marge cypress/reports/index.json --reportDir cypress/reports --inline",
    "cy:del-report": "rm -rf ./cypress/reports && rm -rf ./cypress/screenshots && rm -rf ./cypress/videos"
  },
  "private": true,
  "dependencies": {
    "@amplitude/analytics-browser": "^2.16.0",
    "@angular/animations": "^19.2.8",
    "@angular/common": "^19.2.8",
    "@angular/compiler": "^19.2.8",
    "@angular/core": "^19.2.8",
    "@angular/forms": "^19.2.8",
    "@angular/platform-browser": "^19.2.8",
    "@angular/platform-browser-dynamic": "^19.2.8",
    "@angular/router": "^19.2.8",
    "@capacitor/android": "^6.0.0",
    "@capacitor/app": "6.0.0",
    "@capacitor/barcode-scanner": "^1.0.1",
    "@capacitor/browser": "^6.0.1",
    "@capacitor/camera": "^6.0.1",
    "@capacitor/clipboard": "^6.0.0",
    "@capacitor/core": "^6.0.0",
    "@capacitor/device": "^6.0.0",
    "@capacitor/dialog": "^6.0.0",
    "@capacitor/filesystem": "^6.0.0",
    "@capacitor/geolocation": "^6.0.0",
    "@capacitor/haptics": "6.0.0",
    "@capacitor/ios": "^6.0.0",
    "@capacitor/keyboard": "6.0.0",
    "@capacitor/network": "^6.0.0",
    "@capacitor/preferences": "^6.0.1",
    "@capacitor/push-notifications": "^6.0.1",
    "@capacitor/share": "^6.0.3",
    "@capacitor/splash-screen": "^6.0.1",
    "@capacitor/status-bar": "6.0.0",
    "@capgo/capacitor-updater": "^6.1.13",
    "@capgo/native-market": "^6.0.1",
    "@chemist2u/types-client": "1.2.41",
    "@ionic/angular": "8.5.5",
    "@sentry/angular": "8.55.0",
    "@sentry/capacitor": "1.4.0",
    "@sentry/cli": "^2.36.1",
    "angularx-qrcode": "19.0.0",
    "capacitor-native-biometric": "^4.2.2",
    "capacitor-native-settings": "^6.0.1",
    "date-fns": "4.1.0",
    "ionicons": "^7.2.1",
    "jsqr": "^1.4.0",
    "localforage": "^1.10.0",
    "parse": "5.3.0",
    "rxjs": "~7.8.0",
    "swiper": "^11.1.4",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.9",
    "@angular-eslint/builder": "^19.3.0",
    "@angular-eslint/eslint-plugin": "^19.3.0",
    "@angular-eslint/eslint-plugin-template": "^19.3.0",
    "@angular-eslint/schematics": "^19.3.0",
    "@angular-eslint/template-parser": "^19.3.0",
    "@angular/cli": "^19.2.9",
    "@angular/compiler-cli": "^19.2.8",
    "@angular/language-service": "^19.2.8",
    "@capacitor/cli": "^6.0.0",
    "@capgo/cli": "^4.21.13",
    "@cypress/schematic": "^2.5.2",
    "@googlemaps/google-maps-services-js": "3.4.1",
    "@ionic/angular-toolkit": "12.2.0",
    "@types/date-fns": "2.6.3",
    "@types/jasmine": "5.1.7",
    "@types/parse": "3.0.9",
    "@typescript-eslint/eslint-plugin": "8.30.1",
    "@typescript-eslint/parser": "8.30.1",
    "cypress": "^13.14.2",
    "cypress-iframe": "^1.0.1",
    "cypress-real-events": "^1.13.0",
    "eslint": "9.24.0",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-jsdoc": "50.6.9",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "jasmine-core": "~5.1.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "mochawesome": "^7.1.3",
    "mochawesome-merge": "^4.3.0",
    "typescript": "~5.5.0"
  },
  "description": "Chemist2U - Medicine Delivery App"
}
